import React, { useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import makeStyles from '@mui/styles/makeStyles';
import { DateFormatter } from '../../../utilities/formatters';
import request from '../../../utilities/request';
import * as config from './../../../config';

const useStyles = makeStyles({
    details: {
        paddingTop: '0.5rem',
        '& > em': {
            paddingRight: '0.5rem',
        },
    },
});

const ContractDetails = (props) => {
    const classes = useStyles();
    const [isLoading, setIsLoading] = useState(true);
    const [data, setData] = useState(null);
    const { open, id, onClose } = props;

    useEffect(() => {
        async function fetchData() {
            setIsLoading(true);
            const response = await request.get(
                `${config.API_BASE_URL}/contract/${id}`
            );
            setData({ ...response.data.data });
            setIsLoading(false);
        }
        if (id) {
            fetchData();
        }
    }, [id]);

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>Contract Details</DialogTitle>
            {!isLoading ? (
                <DialogContent dividers>
                    <Typography variant="h5" component="h3">
                        {data.title}
                    </Typography>
                    <div className={classes.details}>
                        <em>
                            <strong>Issuer:</strong> {data.issuer}
                        </em>
                        <em>
                            <strong>Date Published:</strong>{' '}
                            <DateFormatter
                                value={data.published_on}
                                format="date"
                            />
                        </em>
                        <em>
                            <strong>Date Signed:</strong>{' '}
                            <DateFormatter
                                value={data.signed_on}
                                format="date"
                            />
                        </em>
                    </div>
                    <p>Here are the details for {data.title}</p>
                </DialogContent>
            ) : (
                <LinearProgress />
            )}
            <DialogActions>
                <Button onClick={onClose}>Close</Button>
            </DialogActions>
        </Dialog>
    );
};

export default ContractDetails;
